import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
          <i className="ri-error-warning-line text-4xl"></i>
        </div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
          404
        </h1>
        <p className="text-foreground-500 mb-6 max-w-md mx-auto">
          抱歉，您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页浏览精彩内容。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}